// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-29zUj","right":"right-2M7rg"};